import { render, staticRenderFns } from "./coursePlay.vue?vue&type=template&id=460cbca2&scoped=true"
import script from "./coursePlay.vue?vue&type=script&lang=js"
export * from "./coursePlay.vue?vue&type=script&lang=js"
import style0 from "./coursePlay.vue?vue&type=style&index=0&id=460cbca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460cbca2",
  null
  
)

export default component.exports